"use strict";

require('../../layouts/web');

$(document).ready(function() {
    $('.product-page').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        nav: true,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
        }
    });

    $('.product-features').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            800: {
                items: 4,
            },
            1000: {
                items: 5,
            }
        }
    });

    $('.owl-cart').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: false,
        responsiveClass: true,
    });

    $('.banner-slider').owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            800: {
                items: 4,
            },
            1000: {
                items: 5,
            },
            1300: {
                items: 6,
            }
        }
    });

    var accordionButtonAdmin = $('.admin-button');
    var accordionButtonVendor = $('.vendor-button');

    var adminCarousel = $('#adminCarousel');
    var vendorCarousel = $('#vendorCarousel');

    accordionButtonAdmin.on('click', function() {
        var buttonIndex = $(this).closest('.accordion-item').index();

        adminCarousel.trigger('to.owl.carousel', buttonIndex);
        // vendorCarousel.trigger('to.owl.carousel', buttonIndex);
    });
    accordionButtonVendor.on('click', function() {
        var buttonIndex = $(this).closest('.accordion-item').index();

        // adminCarousel.trigger('to.owl.carousel', buttonIndex);
        vendorCarousel.trigger('to.owl.carousel', buttonIndex);
    });
    var slideDwellTime = 4000;
    var transitionTime = slideDwellTime / 1000;
    injectStyles('.progress-bar {transition: width ' + transitionTime + 's ease-in }');
    $(".card").eq(0).find(".progress-bar").addClass("animate-bar");
});

function injectStyles(rule) {
    var div = $("<div />", {
        html: '&shy;<style>' + rule + '</style>'
    }).appendTo("body");
}